import { render, staticRenderFns } from "./ForecastingPrediction.vue?vue&type=template&id=65c7f12e"
import script from "./ForecastingPrediction.vue?vue&type=script&lang=js"
export * from "./ForecastingPrediction.vue?vue&type=script&lang=js"
import style0 from "./ForecastingPrediction.vue?vue&type=style&index=0&id=65c7f12e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports